import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console or error reporting service
    console.error('Landing page error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // You can also log the error to an error reporting service here
    // logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <h2>Something went wrong</h2>
            <p>
              We're sorry, but something unexpected happened. Please try refreshing the page.
            </p>
            <button 
              onClick={() => window.location.reload()}
              className="error-boundary-button"
            >
              Refresh Page
            </button>
            
            {process.env.NODE_ENV === 'development' && (
              <details className="error-details">
                <summary>Error Details (Development Only)</summary>
                <pre>{this.state.error && this.state.error.toString()}</pre>
                <pre>{this.state.errorInfo.componentStack}</pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// Functional component wrapper for specific sections
export const SectionErrorBoundary = ({ children, sectionName = "section" }) => (
  <ErrorBoundary>
    <ErrorFallback sectionName={sectionName}>
      {children}
    </ErrorFallback>
  </ErrorBoundary>
);

// Simple error fallback component
const ErrorFallback = ({ children, sectionName }) => {
  try {
    return children;
  } catch (error) {
    console.error(`Error in ${sectionName}:`, error);
    return (
      <div className="section-error-fallback">
        <p>Unable to load {sectionName}. Please try refreshing the page.</p>
      </div>
    );
  }
};

export default ErrorBoundary;